import { baseUrl } from '@/utils/request.js'
import { Message } from 'element-ui'
import _ from 'lodash'

const timer = null
const baseURL = baseUrl // 默认URL
// eslint-disable-next-line no-unused-vars
let setIntervalWesocketPush = null // 心跳定时器
/**
 * websocket控制类
 * 在此新增、编辑、删除、获取websocket
 * */
class WebsocketFeature {
  // eslint-disable-next-line camelcase
  websocket_container // websocket容器
  constructor() {
    this.websocket_container = new Map() // 初始化
  }

  /**
   * 创建新的websocket
   * @param urlV：
   * 如果是带着wss://或者ws://的字符串，则视为完整的websocketURL,直接作为WebSocket实例化的参数，
   * 如果是普通字符串，则视为拼接到websocketURL后面的参数
   * @param callback：回调函数，用于获取onmessage事件返回的数据
   * @param key: websocketKey，不传值时自动生成，传值时使用给定key
   * @returns 返回websocketKey
   */
  create(urlV, callback, key) {
    let url = baseURL
    if (typeof urlV === 'string' && urlV.constructor === String) {
      if (urlV.match(/wss?:\/\//g)) {
        url = urlV
      } else {
        url += urlV
      }
    }
    const websocketValue = new WebSocket(url)
    websocketValue.onmessage = function (e) {
      callback(e)
    }
    websocketValue.onclose = function (e) {
      console.log('断开连接', e)
      this.closePing()
    }.bind(this)
    websocketValue.onopen = function () {
      this.sendPing(websocketValue)
    }.bind(this)
    // 连接发生错误,第一时间清楚容器里的websocket
    websocketValue.onerror = function (e) {
      console.log(e)
      Message.error('WebSocket连接发生错误')
      // console.log(websocketKey, "========");
      // timer = setTimeout(
      //   function () {
      //     this.create(urlV, callback, websocketKey)
      //   }.bind(this),
      //   10000
      // )
    }
    // 生成唯一键值
    // const websocketKey = Symbol(websocketValue);
    let websocketKey
    if (key) {
      websocketKey = key
    } else {
      websocketKey = Symbol(url)
    }
    this.websocket_container.set(websocketKey, websocketValue)
    return websocketKey
  }

  /** 发送数据
 1. @param obj
 */
  send(key, obj) {
    const Socket = this.websocket_container.get(key)
    const url = _.cloneDeep(Socket.url)
    const callback = Socket.onmessage

    if (Socket !== null && Socket.readyState === 3) {
      console.log('重连')
      Socket.close()
      this.create(url, callback, key) // 重连
      return false
    } else if (Socket.readyState === 1) {
      console.log('WebSocket的链接已经建立')
      Socket.send(obj)
      return true
    } else if (Socket.readyState === 0) {
      console.log('连接尚未建立')
      setTimeout(() => {
        Socket.send(obj)
        return true
      }, 3000)
    }
    return false
  }

  /**
   * 根据key获取websocket实例
   * @param key 唯一键值
   * @returns websocket实例或者undefined
   */
  get(key) {
    return this.websocket_container.get(key)
  }

  /**
   * 根据key删除websocket实例，并关闭连接
   * @param key 唯一键值
   * @returns true:成功；false失败
   */
  remove(key) {
    if (this.websocket_container.has(key)) {
      const websocket = this.websocket_container.get(key)
      websocket.close()
      clearTimeout(timer)
      return this.websocket_container.delete(key)
    } else {
      return false
    }
  }

  /**
   * 清理websocket容器中连接已经关闭或者打开链接失败的websocket
   */
  clear() {
    for (const [key, value] of this.websocket_container.entries()) {
      if (value.readyState === WebSocket.CLOSED) {
        this.websocket_container.delete(key)
      }
    }
  }

  /** 发送心跳 */
  sendPing(Socket) {
    setIntervalWesocketPush = setInterval(() => {
      Socket.send('ping')
    }, 10000)
  }

  /** 关闭心跳 **/
  closePing() {
    clearInterval(setIntervalWesocketPush)
  }
}
const websocketFeature = new WebsocketFeature()
export default websocketFeature
